module.exports = __webpack_public_path__ + "img/Morphling.fae37a91.png";